import ApplicationAdapter from './application';

export default class InAppMessageTemplateAdapter extends ApplicationAdapter {
  buildURL() {
    return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/in_app/messages`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'in-app-message-template': InAppMessageTemplateAdapter;
  }
}
